import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import saveAs from 'file-saver';
import { SharedModule } from 'src/app/shared/shared.module';
import { NoonReportsService } from 'src/app/transportation/vessels/services/noon-reports.service';

@Component({
  selector: 'app-summery-report-toolbar',
  templateUrl: './fleet-summery-report-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, MatButtonModule],
})
export class SummeryReportToolbarComponent {
  constructor(
        private _noonReportService: NoonReportsService,) { }

  downloadReport() {
    this._noonReportService.getVesselLatestReportExcel().subscribe(b => {
      saveAs(b.body!, 'latest-reports.xlsx');
    });
  }
}
